import React, { useState } from 'react';
import Scanner from 'react-qr-barcode-scanner';
import { Result } from '@zxing/library';

interface BarcodeScannerProps {
  onBarcodeScanned: (barcode: string) => void; 
}

const BarcodeScanner: React.FC<BarcodeScannerProps> = ({ onBarcodeScanned }) => {
  const [error, setError] = useState<string | null>(null);

  const handleScan = (result: string) => {
    onBarcodeScanned(result); 
  };

  const handleError = (error: string) => {
    setError(error);
  };

  return (
    <div>
      <Scanner
        onUpdate={(err: unknown, result: Result | undefined) => {
          if (err instanceof Error) {
            handleError(err.message);
          } else if (result) {
            handleScan(result.getText());
          }
        }}
      />
      {/* {error && <p style={{ color: 'red' }}>Error: {error}</p>} */}
    </div>
  );
};

export default BarcodeScanner;
